<div class="flex flex-col justify-stretch">
	<mat-toolbar class="mat-toolbar-tg mat-toolbar-base flex h-initial flex-row items-center justify-start gap-2">
		<shell-menu-toggle></shell-menu-toggle>
		<div
			class="flex flex-auto flex-col items-start justify-start gap-1 sm:flex-row sm:items-center sm:justify-start sm:gap-2"
		>
			<ng-container *ngTemplateOutlet="insightTypeTemplate"></ng-container>
		</div>
		<div class="flex-auto"></div>
		<div
			class="flex flex-row items-center justify-start gap-4"
			fxHide.lt-sm
			teams-hide
		>
			<mat-divider
				class="h-8"
				vertical
			></mat-divider>
			<app-user-menu></app-user-menu>
		</div>
	</mat-toolbar>
	<ng-container *ngIf="insightType$ | async as type">
		<mat-toolbar
			*ngIf="type === 1"
			class="mat-toolbar-secondary mat-toolbar-mw gap-4"
		>
			<div class="flex flex-auto flex-row items-center justify-start gap-4 pb-2 pt-3">
				<div
					class="mat-hint mat-typography font-bold"
					fxHide.lt-sm
				>
					{{ 'utils.filter' | translate }}:
				</div>
				<div class="flex flex-row items-center justify-start gap-2">
					<button
						(click)="ptrigger.popover.toggle()"
						[active]="(projectsFilter$ | async)?.length > 0"
						[count]="(projectsFilter$ | async)?.length ?? 0"
						[satPopoverAnchor]="projectFilterPopover"
						#ptrigger="satPopoverAnchor"
						icon="folder"
						labelKey="reports.filter-bar.projects"
						tgFilterTrigger
					></button>
				</div>
			</div>
		</mat-toolbar>
		<mat-toolbar
			*ngIf="type === 2"
			class="mat-toolbar-secondary mat-toolbar-mw gap-4"
		>
			<div class="flex flex-auto flex-row items-center justify-start gap-4 pb-2 pt-3">
				<div
					class="mat-hint mat-typography font-bold"
					fxHide.lt-sm
				>
					{{ 'utils.filter' | translate }}:
				</div>
				<div class="flex flex-row items-center justify-start gap-2">
					<button
						(click)="ptrigger.popover.toggle()"
						[active]="(employeeFilter$ | async)?.length > 0"
						[count]="(employeeFilter$ | async)?.length ?? 0"
						[satPopoverAnchor]="employeeFilterPopover"
						#ptrigger="satPopoverAnchor"
						icon="supervisor_account"
						labelKey="reports.filter-bar.users"
						tgFilterTrigger
					></button>
				</div>
			</div>
		</mat-toolbar>
	</ng-container>
</div>
<div class="container-wrapper">
	<div class="container-content">
		<div class="container-fluid flex flex-col justify-stretch gap-3 pb-48">
			<div class="mt-4 flex flex-row"><app-time-range-picker [(range)]="range"></app-time-range-picker></div>
			<ng-container *ngIf="insightType$ | async as type">
				<ng-container
					*ngTemplateOutlet="
            type === 1 ? projectProfit : type === 2 ? employeeProfit : null;
            context: { $implicit: (data$graph | async) }
          "
				></ng-container>
				<ng-container
					*ngTemplateOutlet="type === 1 ? projectTable : type === 2 ? employeeTable : null"
				></ng-container>
			</ng-container>
		</div>
	</div>
</div>
<ng-template #insightTypeTemplate>
	<div class="nav-container flex flex-row items-center justify-start gap-3">
		<a
			(click)="insightTypeControl.setValue(1); $event.preventDefault()"
			[class.active]="insightTypeControl.value === 1"
			class="nav-item dash-nav-item"
			href="#"
		>
			{{ 'insights.project-profitability' | translate }}
		</a>
		<div class="mx-3">
			<mat-divider
				class="h-8 rotate-6"
				inset
				vertical
			></mat-divider>
		</div>
		<a
			(click)="insightTypeControl.setValue(2); $event.preventDefault()"
			[class.active]="insightTypeControl.value === 2"
			class="nav-item dash-nav-item"
			href="#"
		>
			{{ 'insights.employee-profitability' | translate }}
		</a>
	</div>
</ng-template>
<tg-project-filter-popover
	(selectedItemsChange)="projectsFilter = $event"
	#projectFilterPopover
></tg-project-filter-popover>
<tg-employee-filter-popover
	(selectedItemsChange)="employeeFilter = $event"
	#employeeFilterPopover
></tg-employee-filter-popover>
<ng-template
	#projectProfit
	let-graphData
>
	<tg-project-profitability-graph
		[data]="graphData"
		style="height: 450px"
	></tg-project-profitability-graph>
</ng-template>
<ng-template
	#employeeProfit
	let-graphData
>
	<tg-employee-profitability-graph
		[data]="graphData"
		style="height: 450px"
	></tg-employee-profitability-graph>
</ng-template>
<ng-template #employeeTable>
	<mat-card *ngIf="this.data$table$employee | async as data">
		<mat-card-content>
			<div
				class="mat-typography mb-3 flex w-full flex-col gap-0 sm:gap-2 md:flex-row md:items-center md:justify-between"
			>
				<div class="flex flex-col gap-1">
					<div class="font-bold uppercase">{{ 'insights.employee-earnings' | translate }}</div>
					<div class="text-xl uppercase">{{ data.earnings | customCurrency }}</div>
				</div>
				<div class="flex flex-col gap-1">
					<div class="text-base font-bold uppercase">{{ 'insights.labor-cost' | translate }}</div>
					<div class="text-xl uppercase">{{ data.labor | customCurrency }}</div>
				</div>
				<div class="flex flex-col gap-1">
					<div class="text-base font-bold uppercase">{{ 'insights.balance' | translate }}</div>
					<div class="mat-text-accent text-xl uppercase">{{ data.balance | customCurrency }}</div>
				</div>
			</div>
			<div class="-mx-16px my-2"><mat-divider inset></mat-divider></div>
			<div class="flex-table scroll-x -mx-16px mt-4 px-16px pb-16px">
				<div
					(matSortChange)="changeDataSort($event)"
					[matSortActive]="activeSort.active"
					[matSortDirection]="activeSort.direction"
					[matSortDisableClear]="true"
					class="-ml-2 mb-2 grid select-none grid-cols-[10px_340px_220px_180px_180px_180px_180px_180px_40px] flex-row items-center justify-start gap-4 text-sm font-bold uppercase"
					matSort
				>
					<div></div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="name"
						matRipple
					>
						{{ 'insights.employee' | translate }}
					</div>
					<div class="p-2">
						{{ 'insights.earnings' | translate }}
						<span class="mx-1">/</span>
						{{ 'insights.loss' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="timeDiff"
						matRipple
					>
						{{ 'insights.total-hrs' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="billedTimeDiff"
						matRipple
					>
						{{ 'insights.billable' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="earnings.rateCost"
						matRipple
					>
						{{ 'insights.earnings' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="earnings.laborCost"
						matRipple
					>
						{{ 'insights.labor-cost' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="earnings.balance"
						matRipple
					>
						{{ 'insights.balance' | translate }}
					</div>
					<div></div>
				</div>
				<ng-container *ngIf="!isLoading; else loadingSkeleton">
					<ng-container *ngIf="data?.entries?.length > 0; else noEntries">
						<mat-list class="-mx-16px">
							<mat-list-item
								(contextmenu)="
                  openContextMenu($event, contextMenuTrigger, {
                    entity: item,
                    type: data.type,
                  })
                "
								*ngFor="let item of data.entries; trackBy: trackId"
							>
								<div
									class="grid grid-cols-[10px_340px_220px_180px_180px_180px_180px_180px_40px] items-center justify-start gap-4"
								>
									<div class="flex flex-col items-center justify-center">
										<div
											[class.bg-success-10]="item.earnings.balance > 0.0"
											[class.bg-warn-10]="item.earnings.balance <= 0.0"
											class="rounded-circle h-2 w-2"
										></div>
									</div>
									<div
										[queryParams]="buildDashboardQueryParams({ user: item.user.id })"
										[routerLink]="['/dashboard']"
										class="grid cursor-pointer grid-cols-[40px_300px] items-center justify-start gap-4"
									>
										<div>
											<app-user-avatar
												[userId]="item.user.id"
												class="rounded-circle mat-elevation-z3"
												size="40px"
											></app-user-avatar>
										</div>
										<div
											[matTooltip]="userName"
											[matTooltipDisabled]="userName.length < 36"
											*ngIf="item.user.name as userName"
											class="mat-truncate"
										>
											{{ userName | truncate: 36 }}
										</div>
									</div>
									<div
										*ngIf="item.earnings.showGraph; else noGraphValue"
										class="mat-truncate flex flex-col"
									>
										<div class="flex flex-row">
											<span class="earnings-text-win">{{
												item.earnings.rateCost | customCurrency
											}}</span>
											<div class="flex-auto"></div>
											<span class="earnings-text-loss">{{
												item.earnings.laborCost | customCurrency
											}}</span>
										</div>
										<div
											class="earnings-bar-wrapper flex w-full flex-row items-center justify-start"
										>
											<div
												[style.width.%]="item.earnings.profitDiff"
												class="earnings-bar earnings-bar-win"
											></div>
											<div
												[style.width.%]="item.earnings.lossDiff"
												class="earnings-bar earnings-bar-loss"
											></div>
										</div>
										<div class="flex flex-row">
											<span class="earnings-text-win">{{
												item.earnings.profitDiff / 100 | percent
											}}</span>
											<div class="flex-auto"></div>
											<span class="earnings-text-loss">{{
												item.earnings.lossDiff / 100 | percent
											}}</span>
										</div>
									</div>
									<div class="mat-truncate">{{ item.timeDiff | parseMsAsDuration }}</div>
									<div class="mat-truncate">{{ item.billedTimeDiff | parseMsAsDuration }}</div>
									<div class="mat-truncate">{{ item.earnings.rateCost | customCurrency }}</div>
									<div class="mat-truncate">{{ item.earnings.laborCost | customCurrency }}</div>
									<div
										[class.text-warn]="item.earnings.balance < 0.0"
										class="mat-truncate"
									>
										{{ item.earnings.balance | customCurrency }}
									</div>
									<div>
										<button
											[matMenuTriggerData]="{ entity: item, type: data.type }"
											[matMenuTriggerFor]="contextMenu"
											mat-icon-button
										>
											<mat-icon>more_vert</mat-icon>
										</button>
									</div>
								</div>
							</mat-list-item>
						</mat-list>
					</ng-container>
				</ng-container>
			</div>
		</mat-card-content>
	</mat-card>
</ng-template>
<ng-template #projectTable>
	<mat-card *ngIf="this.data$table$project | async as data">
		<mat-card-content>
			<div
				class="mat-typography mb-3 flex w-full flex-col gap-0 sm:gap-2 md:flex-row md:items-center md:justify-between"
			>
				<div class="flex flex-col gap-1">
					<div class="text-base font-bold uppercase">{{ 'insights.project-earnings' | translate }}</div>
					<div class="text-xl uppercase">{{ data.earnings | customCurrency }}</div>
				</div>
				<div class="flex flex-col gap-1">
					<div class="text-base font-bold uppercase">{{ 'insights.labor-cost' | translate }}</div>
					<div class="text-xl uppercase">{{ data.labor | customCurrency }}</div>
				</div>
				<div class="flex flex-col gap-1">
					<div class="text-base font-bold uppercase">{{ 'insights.balance' | translate }}</div>
					<div class="mat-text-accent text-xl uppercase">{{ data.balance | customCurrency }}</div>
				</div>
			</div>
			<div class="-mx-16px my-2"><mat-divider inset></mat-divider></div>
			<div class="flex-table scroll-x -mx-16px mt-4 px-16px pb-16px">
				<div
					(matSortChange)="changeDataSort($event)"
					[matSortActive]="activeSort.active"
					[matSortDirection]="activeSort.direction"
					[matSortDisableClear]="true"
					class="-ml-2 mb-2 grid select-none grid-cols-[10px_300px_20px_220px_180px_180px_180px_180px_180px_40px] items-center justify-start gap-4 text-sm font-bold uppercase"
					matSort
				>
					<div></div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="name"
						matRipple
					>
						{{ 'insights.project' | translate }}
					</div>
					<div></div>
					<div class="p-2">
						{{ 'insights.earnings' | translate }}
						<span class="mx-1">/</span>
						{{ 'insights.loss' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="timeDiff"
						matRipple
					>
						{{ 'insights.total-hrs' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="billedTimeDiff"
						matRipple
					>
						{{ 'insights.billable' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="earnings.rateCost"
						matRipple
					>
						{{ 'insights.earnings' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="earnings.laborCost"
						matRipple
					>
						{{ 'insights.labor-cost' | translate }}
					</div>
					<div
						class="cursor-pointer rounded p-2"
						mat-sort-header="earnings.balance"
						matRipple
					>
						{{ 'insights.balance' | translate }}
					</div>
					<div></div>
				</div>
				<ng-container *ngIf="!isLoading; else loadingSkeleton">
					<ng-container *ngIf="data?.entries?.length > 0; else noEntries">
						<mat-list class="-mx-16px">
							<mat-list-item
								(contextmenu)="
                  openContextMenu($event, contextMenuTrigger, {
                    entity: item,
                    type: data.type,
                  })
                "
								*ngFor="let item of data.entries; trackBy: trackId"
							>
								<div
									class="grid grid-cols-[10px_300px_20px_220px_180px_180px_180px_180px_180px_40px] items-center justify-start gap-4"
								>
									<div class="flex flex-col items-center justify-center">
										<div
											[class.bg-success-10]="item.earnings.balance > 0.0"
											[class.bg-warn-10]="item.earnings.balance <= 0.0"
											class="rounded-circle h-2 w-2"
										></div>
									</div>
									<div
										[matTooltip]="projectName"
										[matTooltipDisabled]="projectName.length < 32"
										*ngIf="item.project | defaultEntityTranslate: 'project' : 'project.none' as projectName"
										class="mat-truncate cursor-default"
									>
										<div class="l-initial flex flex-col">
											<a
												[routerLink]="['/settings/projects', item.project.id]"
												class="mat-truncate link-button"
												>{{
													projectName
												}}</a
											>
											<span
												*ngIf="item.client as client"
												class="mat-truncate mat-hint text-sm"
												>{{
													client | defaultEntityTranslate: 'client' : 'client.none'
												}}</span
											>
										</div>
									</div>
									<div class="flex items-center justify-center">
										<div
											[matTooltip]="'project.completed' | translate"
											*ngIf="item.project.completed"
											class="mat-size-[20px] text-green-500 dark:text-green-400"
										>
											<mat-icon inline>check_circle</mat-icon>
										</div>
									</div>
									<div
										*ngIf="item.earnings.showGraph; else noGraphValue"
										class="mat-truncate flex flex-col"
									>
										<div class="flex flex-row">
											<span class="earnings-text-win">{{
												item.earnings.rateCost | customCurrency
											}}</span>
											<div class="flex-auto"></div>
											<span class="earnings-text-loss">{{
												item.earnings.laborCost | customCurrency
											}}</span>
										</div>
										<div
											class="earnings-bar-wrapper flex w-full flex-row items-center justify-start"
										>
											<div
												[style.width.%]="item.earnings.profitDiff"
												class="earnings-bar earnings-bar-win"
											></div>
											<div
												[style.width.%]="item.earnings.lossDiff"
												class="earnings-bar earnings-bar-loss"
											></div>
										</div>
										<div class="flex flex-row">
											<span class="earnings-text-win">{{
												item.earnings.profitDiff / 100 | percent
											}}</span>
											<div class="flex-auto"></div>
											<span class="earnings-text-loss">{{
												item.earnings.lossDiff / 100 | percent
											}}</span>
										</div>
									</div>
									<div class="mat-truncate">{{ item.timeDiff | parseMsAsDuration }}</div>
									<div class="mat-truncate">{{ item.billedTimeDiff | parseMsAsDuration }}</div>
									<div class="mat-truncate">{{ item.earnings.rateCost | customCurrency }}</div>
									<div class="mat-truncate">{{ item.earnings.laborCost | customCurrency }}</div>
									<div
										[class.text-warn]="item.earnings.balance < 0.0"
										class="mat-truncate"
									>
										{{ item.earnings.balance | customCurrency }}
									</div>
									<div>
										<button
											[matMenuTriggerData]="{ entity: item, type: data.type }"
											[matMenuTriggerFor]="contextMenu"
											mat-icon-button
										>
											<mat-icon>more_vert</mat-icon>
										</button>
									</div>
								</div>
							</mat-list-item>
						</mat-list>
					</ng-container>
				</ng-container>
			</div>
		</mat-card-content>
	</mat-card>
</ng-template>
<ng-template #noValue> <div class="mat-truncate wflex-[0_0_180px]">-</div> </ng-template>
<ng-template #noGraphValue> <div class="mat-truncate wflex-[0_0_220px]">-</div> </ng-template>
<ng-template #noEntries>
	<div class="flex h-48 flex-col items-center justify-center">
		<p
			class="my-0"
			translate
		>
			utils.noitems
		</p>
	</div>
</ng-template>
<ng-template #loadingSkeleton>
	<mat-list class="-mx-16px">
		<mat-list-item *ngFor="let item of [0, 0, 0, 0, 0]">
			<ng-container *ngTemplateOutlet="loadingEntries"></ng-container>
		</mat-list-item>
	</mat-list>
</ng-template>
<ng-template #loadingEntries>
	<div class="flex select-none flex-row items-center justify-start gap-4 text-sm font-bold uppercase">
		<div class="wflex-[0_0_300px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_220px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_180px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_180px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_180px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_180px]">
			<div class="mat-skeleton"></div>
		</div>
		<div class="wflex-[0_0_180px]">
			<div class="mat-skeleton"></div>
		</div>
	</div>
</ng-template>
<div
	[matMenuTriggerFor]="contextMenu"
	[style.left]="contextMenuPosition.x"
	[style.top]="contextMenuPosition.y"
	#contextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<mat-menu #contextMenu="matMenu">
	<ng-template
		let-entity="entity"
		let-type="type"
		matMenuContent
	>
		<div class="flex flex-col">
			<a
				[routerLink]="['/settings', 'projects', entity.project.id]"
				*ngIf="type === 1"
				mat-menu-item
			>
				<mat-icon inline>open_in_new </mat-icon>
				{{ 'project.open' | translate }}
			</a>
			<a
				[queryParams]="
					type === 1
						? buildDashboardQueryParams({ project: entity.project.id })
						: type === 2
							? buildDashboardQueryParams({ user: entity.user.id })
							: null
				"
				[routerLink]="['/dashboard']"
				mat-menu-item
			>
				<mat-icon inline>dashboard </mat-icon>
				{{ 'dashboard.open' | translate }}
			</a>
		</div>
	</ng-template>
</mat-menu>
